import { render } from "./CollectionCard.vue?vue&type=template&id=3a93e29a&scoped=true"
import script from "./CollectionCard.vue?vue&type=script&lang=js"
export * from "./CollectionCard.vue?vue&type=script&lang=js"

import "./CollectionCard.vue?vue&type=style&index=0&id=3a93e29a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a93e29a"]])

export default __exports__